import { useEffect, useState } from 'react';
import find from 'lodash/find';
import filter from 'lodash/filter';
import isMatchWith from 'lodash/isMatchWith';
import unionWith from 'lodash/unionWith';
import reduce from 'lodash/reduce';
import { useStore } from './useStore';
import useBackendSync from "./useBackendSync";
import usePackages from "./usePackages";

const useTicket = () => {
  const [state, dispatch] = useStore();
  const { convertSingles, convertPackage, convertGiftBox, convertGroup } = usePackages();
  const { postUpdate } = useBackendSync();
  const { appData, clientState, tickets, section, isGroup, cartState, calendarType } = state;
  const [totalPeople, setTotalPeople] = useState(1);

  useEffect(() => {
    getCartState();
  }, []);

  const setTicket = async (id, action, qty) => {
    dispatch('RESET_MESSAGES');
    const n = qty ? qty : 1;
    // console.log('thisTicket', thisTicket);
    if (id.includes('family') || id === 'adult_package' || id === 'child_package') {
      breakOut(id, n); // break out packages into a la carte tickets
    } else {
      let ticketsTemp = [...tickets];
      let thisTicket = find(tickets, ['id', id]);

      if (action === 'add') thisTicket.quantity = thisTicket.quantity + n;
      if (action === 'subtract') thisTicket.quantity = thisTicket.quantity - n;
      if (action === 'remove') thisTicket.quantity = 0;

      dispatch('SET', {
        tickets: ticketsTemp
      });
    }
    await setNumbers();
    if (calendarType === 'booking') await setApiState(id, action);
    await Promise.all([getCartState(), postUpdate()]);
  }

  const getCartState = () => {
    // console.log('getCartState', clientState);
    let merged = unionWith(
      {}, clientState.tq, clientState.iq,
      (a, b) => b === null ? a : undefined
    );
    const rows = filter(merged, item => {
      return item.quantity > 0 && !item.id.includes('box') && !item.id.includes('wallet') && item.id !== 'package';
    });
    // console.log('rows', rows);
    dispatch('SET', {
      cartState: rows,
      waiting: false
    });
  }

  const setApiState = (id, action, number) => {
    console.log('setApiState', id);
    console.log('section', section);
    const groupMin = parseInt(appData.ticket_types[section].group_min);
    let tqArr = clientState.tq;
    let iqArr = clientState.iq;

    if (appData.ticket_types[section].has_group_prices) {
      if (!isGroup && totalPeople >= groupMin && action === 'add') {
        tqArr = convertGroup('add');
        dispatch('SET', {
          isGroup: true,
          showGroupMessage: true
        });
      } else if (isGroup && totalPeople < groupMin && action === 'subtract') {
        tqArr = convertGroup('subtract');
        dispatch('SET', {
          isGroup: false
        });
      }
    }
    const n = number ? number : 1;
    switch (id) {
      case 'package':
        console.log('package');
        tqArr = convertPackage(action);
        break;
      case 'gift_box':
      case 'winter_box':
        tqArr = convertGiftBox(action);
        break;
      default:
        let exists = find(tqArr, ['id', id]);
        console.log('exists', exists);
        if (!exists) exists = find(iqArr, ['id', id]);
        if (exists && exists.quantity === 0 && action === 'subtract') {
          breakPackage(id);
          break;
        }
        tqArr = tqArr.map(t => {
          id = (totalPeople >= groupMin && (id === 'adult' || id === 'child')) ? 'group_' + id : id;
          if (t.id === id) {
            if (action === 'add') {
              t.quantity = t.quantity + n;
            } else if (action === 'subtract' && t.quantity > 0) {
              t.quantity = t.quantity - n;
            } else if (action === 'remove') {
              t.quantity = 0;
            }
          }
          return t;
        });

        // iqArr = iqArr.map(i => {
        //   console.log('i', i);
        //   id = (isGroup && (id === 'adult' || id === 'child')) ? 'group_' + id : id;
        //   if (i.id === id) {
        //     if (action === 'add') {
        //       console.log('add', i.id, i.quantity);
        //       i.quantity = i.quantity + n;
        //     } else if (action === 'subtract' && i.quantity > 0) {
        //       i.quantity = i.quantity - n;
        //     } else if (action === 'remove') {
        //       i.quantity = 0;
        //     }
        //   }
        //   return i;
        // });
        break;
    }
    console.log('tqArr', tqArr);
    console.log('iqArr', iqArr);
    dispatch('SET', {
      clientState: {
        tq: tqArr,
        iq: iqArr
      }
    });
    convertSingles(tqArr.concat(iqArr));
  }

  const setNumbers = () => {
    // console.log('setNumbers', tickets);
    const adultTix = find(tickets, ['id', 'adult']);
    const childTix = find(tickets, ['id', 'child']);
    const packageTix = find(tickets, ['id', 'package']);
    const people = adultTix.quantity + childTix.quantity;
    setTotalPeople(people);

    const totalTickets = reduce(tickets, function (result, value) {
      return result + value.quantity;
    }, 0);

    const availablePackages = people - packageTix.quantity;

    dispatch('SET', {
      totals: {
        people: people,
        tickets: totalTickets,
        availablePackages: availablePackages,
        adults: adultTix.quantity
      }
    });
  }

  const breakOut = (id, qty) => {
    tickets.map(t => {
      if (breakOuts[id]) {
        breakOuts[id].forEach(p => {
          if (p.id === t.id) t.quantity = t.quantity + (p.quantity * qty);
        });
        return t;
      }
    });
  }

  const breakPackage = (id) => {
    // console.log('breakPackage', id);
    // console.log('cartState', cartState);
    cartState.forEach(c => {
      if (breakOuts[c.id]) {
        // console.log('HAS PACKAGE', breakOuts[c.id]);
        setApiState(c.id, 'subtract');
        breakOuts[c.id].forEach(p => {
          if (p.id === id) p.quantity--;
          if (p.quantity > 0) {
            // console.log('p', p);
            setApiState(p.id, 'add', p.quantity);
          }
        });
      }
    });
  }

  return {
    breakOut,
    setTicket,
    setApiState
  };
}

const breakOuts = {
  adult_package: [
    {
      id: 'adult',
      quantity: 1
    },
    {
      id: 'package',
      quantity: 1
    }
  ],
  child_package: [
    {
      id: 'child',
      quantity: 1
    },
    {
      id: 'package',
      quantity: 1
    }
  ],
  family_2_2: [
    {
      id: 'adult',
      quantity: 2
    },
    {
      id: 'child',
      quantity: 2
    }
  ],
  family_1_3: [
    {
      id: 'adult',
      quantity: 1
    },
    {
      id: 'child',
      quantity: 3
    }
  ],
  family_2_2_gift: [
    {
      id: 'adult_gift',
      quantity: 2
    },
    {
      id: 'child_gift',
      quantity: 2
    }
  ],
  family_1_3_gift: [
    {
      id: 'adult_gift',
      quantity: 1
    },
    {
      id: 'child_gift',
      quantity: 3
    }
  ],
  family_2_2_gift_box: [
    {
      id: 'adult_gift',
      quantity: 2
    },
    {
      id: 'child_gift',
      quantity: 2
    }
  ],
  family_1_3_gift_box: [
    {
      id: 'adult_gift',
      quantity: 1
    },
    {
      id: 'child_gift',
      quantity: 3
    }
  ]
};

export default useTicket;
